/**
 * The canonical public origin a client would visit to book or view a
 * report. On native Capacitor the WebView runs from `capacitor://flowspect.app`
 * (or `https://localhost`) and `window.location.origin` returns that
 * internal scheme, which is useless to copy/share with a real client.
 *
 * Resolution order:
 *   1. `VITE_PUBLIC_ORIGIN` env var if set (lets each environment — dev,
 *      staging, production — point at its own domain).
 *   2. `window.location.origin` if it looks like a real web origin
 *      (http: or https:, hostname not `localhost`).
 *   3. Fallback to `https://flowspect.app`.
 *
 * Always returns a value with no trailing slash so callers can append
 * `/book/${slug}` cleanly.
 */
export function getPublicOrigin(): string {
  const envOrigin = import.meta.env.VITE_PUBLIC_ORIGIN as string | undefined;
  if (envOrigin && envOrigin.trim()) return envOrigin.trim().replace(/\/$/, '');

  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    const isHttp = origin.startsWith('http://') || origin.startsWith('https://');
    const isLocalhost = origin.includes('://localhost') || origin.includes('://127.0.0.1');
    if (isHttp && !isLocalhost) return origin.replace(/\/$/, '');
  }

  return 'https://flowspect.app';
}
